import styled from 'styled-components';

import {
  Button,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

export const Wrapper = styled(Flex).attrs({
  width: '100%',
})<{ screenfirst?: boolean }>`
  ${props => (props.screenfirst
    ? `
      flex-direction: column;

      & > :first-child {
        margin-bottom: 40px;
      }
    ` : `
      flex-direction: column-reverse;

      & > :first-child {
        margin-top: 40px;
      }
  `)};

  @media (min-width: 992px) {
    flex-direction: row;

    & > :first-child {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
`;

export const FormData = styled(Flex).attrs({
  align: 'center',
  column: true,
  spacing: 30,
})`
  width: 100%;
  align-self: center;

  @media (min-width: 992px) {
    flex: 50%;
    margin-right: 5%;
    align-self: flex-start;
  }

  @media (min-width: 1024px) {
    margin-right: 0;
  }
`;

export const Hyphen = styled.div`
  opacity: 0;
  height: 1px;

  @media (min-width: 992px) {
    height: auto;
    display: inline-block;
    opacity: 1;
  }
`;

export const FormWrap = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  margin: 0 auto;
  max-width: 510px;

  a {
    color: ${props => props.theme.colors.primary};
  }

  @media (min-width: 992px) {
    width: 90%;
  }
`;

export const FormInner = styled(Flex).attrs({
  column: true,
})`
  width: 100%;
  border: 1px solid #a0a0a0;
  box-shadow: 0 0 12px -6px #000;

  img {
    max-width: 100%;
  }
`;

export const FormTitle = styled(Flex).attrs({
  column: true,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  padding: 25px;
  border-radius: 5px 5px 0 0;
  background: #fff;
  color: #121827;
  font-size: 14px;
  font-weight: 900;
  text-align: center;

  & > *:not(:first-child) {
    margin-top: 10px;
  }

  @media (min-width: 992px) {
    font-size: 18px;
  }
`;

export const Location = styled(Flex).attrs({
  width: '100%',
})`
  flex-direction: column;

  & > *:not(:first-child) {
    margin-top: 15px;
  }

  @media (min-width: 992px) {
    flex-direction: row;

    & > *:not(:first-child) {
      width: 150px;
      margin-top: 0px;
      margin-left: 30px;
    }
  }
`;

export const Form = styled(Flex).attrs({
  as: 'form',
})`
  width: 100%;
  background: #fff;
  padding: 0 30px 10px;
  border-radius: 0 0 5px 5px;

  @media (min-width: 500px) {
    .card-expiry > span {
      width: 230px;
    }

    .card-cvc > span {
      width: 150px;
    }
  }
`;

export const SubmitButton = styled(Button).attrs({
  ghost: true,
  type: 'submit',
  appearance: 'primary',
})`
  color: #fff;
  font-size: 18px;
  height: auto;
  padding: 10px 25px;
  border: none;
  background: ${props => props.theme.colors.primaryBright};
  border-radius: 5px;
  width: 100%;
  line-height: 24px;
`;

export const Links = styled(Flex).attrs({
  justify: 'space-between',
})`
  width: 100%;
  max-width: 700px;
  padding: 0 10px;
  margin-top: 40px;

  & > a {
    width: 50%;
  }
`;

export const Statement = styled(Flex).attrs({
  alignSelf: 'center',
})`
  color: #888;
  font-size: 13px;
  text-align: center;
  max-width: 360px;
  margin-top: 30px;
`;

export const EmptyDiv = styled(Flex).attrs({
  justify: 'space-between',
})`
  order: 2;
  width: 100%;
  height: 100px;

  & > a {
    width: 50%;
  }

  @media (min-width: 992px) {
    display: none;
  }
`;

export const AppScreen = styled.img`
  width: 220px;
`;
